import { combineReducers } from 'redux';

import {
  initVideoMenuRequest,
  initVideoMenuSuccess,
  initVideoMenuFail,
  getVideoMenuRequest,
  getVideoMenuFail,
  getVideoMenuSuccess,
  saveVideoMenuRequest,
  saveVideoMenuFail,
  saveVideoMenuSuccess,
  createVideoMenuRequest,
  createVideoMenuSuccess,
  createVideoMenuFail,
  resetCurrentVideoMenu,
} from '../actions';
import { VideoMenuAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { VideoMenu } from '../../../../types/items';

type State = Loadable<VideoMenu>;
type ReducerOf<T extends keyof State> = Reducer<State, VideoMenuAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case resetCurrentVideoMenu.type:
    case getVideoMenuRequest.type:
    case initVideoMenuRequest.type:
      return null;

    case getVideoMenuSuccess.type:
    case createVideoMenuSuccess.type:
    case saveVideoMenuSuccess.type:
    case initVideoMenuSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getVideoMenuRequest.type:
    case createVideoMenuRequest.type:
    case saveVideoMenuRequest.type:
    case initVideoMenuRequest.type:
      return true;

    case getVideoMenuSuccess.type:
    case getVideoMenuFail.type:
    case createVideoMenuSuccess.type:
    case createVideoMenuFail.type:
    case saveVideoMenuSuccess.type:
    case saveVideoMenuFail.type:
    case initVideoMenuSuccess.type:
    case initVideoMenuFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
});
